import { render, staticRenderFns } from "./DossierSearch.vue?vue&type=template&id=2dce26e2&"
import script from "./DossierSearch.vue?vue&type=script&lang=ts&"
export * from "./DossierSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dce26e2')) {
      api.createRecord('2dce26e2', component.options)
    } else {
      api.reload('2dce26e2', component.options)
    }
    module.hot.accept("./DossierSearch.vue?vue&type=template&id=2dce26e2&", function () {
      api.rerender('2dce26e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierSearch.vue"
export default component.exports